import React from 'react';
import {
  ApiButton,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'web-library';
import { useLocation } from 'react-router-dom';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { candidateService } from '../../../api';
import { parseLocationSearch } from '../../../utils/StringUtils';
import { usePostCreateGroupExamRegistration } from '../../../api-refactored/group-exam-registration/usePostCreateGroupExamRegistration';

interface ProceedSupplementaryModalProps {
  modelOpen: boolean;
  setModelOpen: (arg: boolean) => void;
  callbackMethod: (uuid: string) => void;
  draftUuid?: string;
  examType?: string;
}

const ProceedGroupSupplementaryModal = ({
  modelOpen,
  setModelOpen,
  callbackMethod,
  draftUuid = '',
  examType = '',
}: ProceedSupplementaryModalProps) => {
  const { t } = useTranslation();

  const location = useLocation();

  const { token = null } = parseLocationSearch(location.search);

  const createExamRegistrationMutation = usePostCreateGroupExamRegistration({
    examType,
    onSuccess: (res) => {
      setModelOpen(false);
      callbackMethod(res.uuid);
    },
    token,
  });
  const onProceedConfirm = (uuid: string) => {
    deleteDraft.mutate(uuid);
  };

  const onClose = () => {
    setModelOpen(false);
  };

  const deleteDraft = candidateService.exam.candidate.useDeleteExamRegistrationDraft(
    () => {
      createExamRegistrationMutation.mutate();
    },
    () => null,
    () => null
  );

  return (
    <Dialog open={modelOpen} maxWidth="sm">
      <DialogTitle>{t('exam->>SupplementaryRegistration.ProceedRegistrationTitle')}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          {t('exam->>SupplementaryRegistration.ProceedRegistrationConfirmationMsg')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button type="button" variant="text" onClick={onClose}>
          {t('exam->>SupplementaryRegistration.Cancel')}
        </Button>
        <ApiButton
          id="button-deleteDraftModal"
          type="button"
          status={deleteDraft.status}
          onClick={() => onProceedConfirm(draftUuid)}
        >
          {t('exam->>SupplementaryRegistration.Proceed')}
        </ApiButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProceedGroupSupplementaryModal;
